import { AppState } from 'types/AppState';
import User from 'types/User';

const selectors = {
  user: (state: AppState): User => state.session.loginUser,
  errorMessage: (state: AppState): string => state.session.errorMessage,
};

export default selectors;
